<script>
import {permissionMixin} from "@/mixins/permissionMixins";
import AppLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "NumberOfIllnessPart",
  mixins:[permissionMixin],
  components: {AppLoading},
  data() {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - 5 + i);
    return {
      loading : true,
      years,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          events:{
            xAxisLabelClick: function(event, chartContext, config){
              if (this.isAllowed('menu.reports.accident-incident') === false) {
                return;
              }
              const ailment_name = this.number_of_illness_part[config.labelIndex].name;
              const data = this.number_of_illness_part[config.labelIndex].data;

              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', true);
              $('#safetyAndHealthModal').modal('show');

              const data_table = {
                text_header : `Type of Illness (${ailment_name})`,
                safety_and_health_module : 'number_of_illness_part',
                data : data
              };

              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_CHART_DATA', data_table)
              this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_DATA_LOADING', false);

              return event.target.innerHTML;
            }.bind(this)
          }
        },
        title: {
          text: 'TYPE OF ILLNESS',
          align: 'center',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          colors: ['#000']
        },
        tooltip: {
          followCursor : true,
          shared: true,
          intersect: false
        },
        fill: {
          colors: ['#bfbfbf', '#a6a6a6', '#ffd966', '#f7caac', '#f4b083', '#ff0000']
        },
        grid: {
          borderColor: '#e9e9e9',
          position: 'front',
          xaxis: {
            lines: {
              show: true,
            }
          }
        },
        xaxis: {
          categories: [],
        },
      },
    }
  },
  methods : {
    ...mapActions(['getAccidentSafetyAndHealthChartsData'])
  },
  mounted() {
    const yearsColors=['#bfbfbf','#a6a6a6','#ffd966','#f7caac','#f4b083','#ff0000']
    this.chartOptions.xaxis.categories = this.number_of_illness_part.map(item => {
      return item.name.toUpperCase()
    })

    this.years.forEach((year, index) => {
      let yearData = [];
      this.number_of_illness_part.forEach(item => {
        item.data.forEach(lossData => {
          if (lossData.year === year) {
            yearData.push(lossData.values.length);
          }
        })
      });
      this.series.push({
        color : yearsColors[index],
        name : year,
        data : yearData
      })
    });
  },
  computed : {
    ...mapGetters([
      'airSafetyAndHealthGraphDataLoading',
      'number_of_illness_part',
      'cmsRequestedOnBoardCrew',
    ]),
  }
}
</script>

<template>
  <div>
    <div v-if="airSafetyAndHealthGraphDataLoading">
      <app-loading></app-loading>
    </div>
    <div v-else>
      <apexchart
        type="bar"
        :height="chartOptions.xaxis.categories.length * 30"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>

  </div>
</template>

<style scoped>

</style>
